module.exports = __webpack_public_path__ + "static/media/adipometro.8d68e750.svg";